import './mail-outgoing-selection-info.ajscss';

import { RecipientSearchType } from '@agent/core/channel-digit/mail/models/recipient';
import { IOutgoingMailDeprecatedService } from '@agent/core/channel-digit/mail/outgoing-mail-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IContact } from '@commons/models/contact';
import { IComponentController, IComponentOptions, ILogService } from 'angular';
import { i18n } from 'i18next';
import moment from 'moment';

import templateUrl from './mail-outgoing-selection-info.template.html';

class MailOutgoingSelectionInfoCtrl implements IComponentController {
  responseId: string;

  localContactNumber: string;

  dialedNumber: string;

  waitedTime: string;

  constructor(
    private readonly $log: ILogService,
    private readonly $i18next: i18n,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly outgoingMailDeprecatedService: IOutgoingMailDeprecatedService
  ) {}

  get contactNumber(): string {
    const contact = this.outgoingMailDeprecatedService.getSelectedContact();
    if (contact && this.outgoingMailDeprecatedService.getSelectedRecipientType() !== RecipientSearchType.BY_CONTACT_ID) {
      this.localContactNumber = contact.email;
    }
    return this.localContactNumber;
  }

  $onInit(): void {
    this.$log.info('[MailInfoCtrl] loaded');
    this.contactDeprecatedService.getContact(this.responseId).then(
      contact => {
        this.localContactNumber = contact.phoneNumber;
        this.dialedNumber = contact.dialedNumber;
        this.waitedTime = this.buildWaitedTime(contact);
      },
      error => {
        this.$log.error(error);
      }
    );
  }

  private buildWaitedTime(contact: IContact): string {
    let waitedMoment = moment.unix(Math.round(contact.waitedTime / 1000)).utc();
    return this.$i18next.t('agent:contact.info.waited_time', {
      minutes: waitedMoment.minutes(),
      seconds: waitedMoment.seconds(),
    });
  }
}

export class MailOutgoingSelectionInfo implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['$log', '$i18next', 'contactDeprecatedService', 'outgoingMailDeprecatedService', MailOutgoingSelectionInfoCtrl];
}

export default 'contactMailOutgoingSelectionInfo';
